import React, { Component } from 'react';
import Input from '../component/Input.js';
import Submit from '../component/Submit.js';
import axios from 'axios';
import Modal from 'react-modal';
import RecoverPassword from './RecoverPassword.js'; //page that asks for user email and emails them their current password
import ResetPassword from './ResetPassword.js'; //page that allows user to reset their password
import SetUserLogin from './SetUserLogin.js'; //page that promps user for security information on first login
import {loginPath} from './routes.js';
import loader from '../asset/img/loader.gif';

Modal.setAppElement('#root'); //provide anchor div for react-modal (required)

export default class LoginPage extends Component{
	constructor(props){
		super(props);
		this.state = {success:false,modalIsOpen:false,email:'',password:'',recover:false,reset:false,userInfo:'',firstLogin:false,failPrompt:'',loading:false, ack: false};
		this.loginAttempt = this.loginAttempt.bind(this);
		this.handleInput = this.handleInput.bind(this);
		this.recoverPass = this.recoverPass.bind(this);
		this.resetPass = this.resetPass.bind(this);
		this.firstLogin = this.firstLogin.bind(this);
		this.openModal = this.openModal.bind(this);
    	this.closeModal = this.closeModal.bind(this);
    	this.enterButtonListener = this.enterButtonListener.bind(this);
		this.welcomeBackAck = this.welcomeBackAck.bind(this);
	}

	resetPass(){ //method to display ResetPassword page in modal
		this.setState({reset:true,recover:false,failPrompt:''},function(){
			this.openModal();
		});
	}

	recoverPass(){//method to display RecoverPassword page in modal
		this.setState({recover:true,reset:false,failPrompt:''},function(){
			this.openModal();
		});
	}

	firstLogin(){ //method to display SetUserLogin page in modal (only on first user login)
		this.setState({firstLogin:true},function(){
			this.openModal();
		});
	}

	handleInput(identity,value){ //standard method for handling user input
		const theState = {};
		theState[identity] = value;
		this.setState(theState);
	}

	enterButtonListener(e){
		if(e.keyCode == 13){
			this.loginAttempt();
		}
	}

	loginAttempt(){ //method for handling user login
		this.setState({loading:true,modalIsOpen:true});
		axios({
			method:'post',
			url:loginPath,
			//data:{"endpoint":"info","table":"users","action":"login","kind":this.state.password,"name":this.state.email}
			data:{"action":"login","password":this.state.password,"email":this.state.email}
			// headers:{"Content-Type":"application/json"}
		}).then((response)=>{
			console.log(response);
				const info = response.data.data;
				if(info.Message === "success"){ //login is a success, pass up userinfo 
					this.setState({success:true,userType:info.user_type,failPrompt:'',loading:false,modalIsOpen:false},
						function(){
							this.props.onLogin(this.state.success,{email:this.state.email,name:info.name,userType:info.user_type,department:info.department,userID:info.userID,redeemable:info.redeemable,budget:info.budget});
						}
					);
				}else if(info.Message === "first"){ //display SetUserLogin page and pass up userinfo
					this.setState({userInfo:{email:this.state.email,name:info.name,userType:info.user_type,department:info.department,userID:info.userID,redeemable:info.redeemable,budget:info.budget},failPrompt:'',loading:false},
						function(){
							this.firstLogin();
						}
					);
				}else{ //login attempt failed
					this.setState({failPrompt:info.Message,loading:false,modalIsOpen:false});
				}
		}).catch((err)=>{ //login failed due to connection
			console.log(err);
			if (!err.response || err.message === 'Network Error') {
				this.setState({
					failPrompt: 'Connection timed out. Please ensure you are on the GF Network.',
					loading: false,
					modalIsOpen: false
				});
			} else {
				this.setState({
					failPrompt:'An error has occured. Please try again later or contact an admin.',
					loading:false,
					modalIsOpen:false
				});
			}
		});	
	}

	componentDidMount(){
		if (window.location.search) {
			const token = new URLSearchParams(window.location.search).get('token');
			if (token) {
				window.history.replaceState({}, '', window.location.pathname);
    			this.setState({loading:true,modalIsOpen:true});
				axios({
					method:'post',
					url:loginPath,
					data:{"action":"account", "token": token}
				}).then((response)=>{
					const info = response.data.data;
					if(info.Message === "first"){
						this.setState({userInfo:{email:info.email,name:info.name,userType:info.user_type,department:info.department,userID:info.userID,redeemable:info.redeemable,budget:info.budget},failPrompt:'',loading:false},
							function(){
								this.firstLogin();
							}
						);
					}else{ //attempt failed
						this.setState({failPrompt:info.Message,loading:false,modalIsOpen:false});
					}
				}).catch((err)=>{ //attempt failed due to connection
					console.log(err);
					if (!err.response || err.message === 'Network Error') {
						this.setState({
							failPrompt: 'Connection timed out. Please ensure you are on the GF Network.',
							loading: false,
							modalIsOpen: false
						});
					} else {
						this.setState({
							failPrompt:'An error has occured. Please try again later or contact an admin.',
							loading:false,
							modalIsOpen:false
						});
					}
				});	
			} else {
				// Check disclaimer
				const stored = localStorage.getItem('welcome-back');
				if( !(stored === 'acknowledged') ){
					this.setState({ack: true}, function(){
						this.openModal();
					});
				}
			}
		} else {
			// Check disclaimer
			const stored = localStorage.getItem('welcome-back');
			if( !(stored === 'acknowledged') ){
				this.setState({ack: true}, function(){
					this.openModal();
				});
			}
		}
	}

	welcomeBackAck() {
		localStorage.setItem('welcome-back', 'acknowledged');
	}

	openModal() { //method to open the modal
    	this.setState({modalIsOpen: true});
	}

	closeModal() { //method to close the modal
	    this.setState({modalIsOpen: false,recover:false,reset:false,firstLogin:false});
	}

	render(){
		let customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'100%',
		    minHeight:'225px',
		    maxWidth:'800px',
		    transform: 'translate(-50%, -50%)',
		    backgroundColor:'white',
		    backgroundBack:'transparent',
		    opacity:1,
		    background:'transparent',
		    boxShadow:'0.5px 0.5px 1px 0.5px',
		  }, 
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			}
		};
		const inputStyles = "hh3 pl1 pr3 br2 bw1 w-100 shadow-3 tc ";
		let modalContent;
		if(!this.state.loading){
			if(this.state.recover){ //display RecoverPassword component
				modalContent = <div>
									<div className="fl w-100 tr">
									 	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
									</div>
									<RecoverPassword />
								</div>;
			}else if(this.state.reset){ //display ResetPassword component
				modalContent = <div>
									<div className="fl w-100 tr">
										<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
									</div>
									<ResetPassword />
								</div>;
			}else if(this.state.firstLogin){ //display SetUserLogin component
				modalContent = <div>
									<div className="fl w-100 tr">
										<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
									</div>
									<SetUserLogin success={this.props.onLogin} pass={this.state.password} info={this.state.userInfo} close={this.closeModal}/>
								</div>;
			}else if(this.state.ack){
				modalContent = <div>
									<div className="fl w-100 tr">
										<button 
											className="bg-white gray b br3" 
											onClick={() => {
												this.welcomeBackAck();
												this.closeModal();
											}}
										>X</button>
									</div>
									<div className="fl w-100">
										<h2 className="mt0 gf dark-blue">Welcome Back!</h2>
										<p style={{lineHeight: '1.8', fontSize: '1.2rem'}}>Welcome back to Living Our Values! If this is your first time back since the application has been back online, please click the <a href="#" className="blue no-underline underline-hover" onClick={() => {this.welcomeBackAck(); this.recoverPass()}}>Recover Account</a> link below the login button. Once you provide your account email address, you will receive an email with a link that allows for you to reset your security information.</p>
									</div>
								</div>
			}
		}else{ //display loading gif
			customStyles.content.maxWidth = '400px';
			customStyles.content.minHeight = '100px'; 
			modalContent = <div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading" /></div>;
		}
		let promptStyle = {fontSize:'.8em'};
		let prompt = <span className="mt0 mb0 pa0" style={promptStyle}>&nbsp;</span>;
		if(this.state.failPrompt !== ''){ //display error message
			prompt = <span className="red mt0 mb0 pa0" style={promptStyle}>*{this.state.failPrompt}</span>;
		}
		return(
			<div className="center pb3 bg-white mt5 mb5 w-40-ns w-50-m w-80" style={{height:'100%'}}>
				<div>
					<h2 className="dark-blue tc mb0">USER LOGIN</h2>
				</div>
				{prompt}
				<div className="tc mt3 w-100 mb3 mt0" style={{minHeight:'45px'}}>
					<Input identity="email" inputStyle={inputStyles} placeholder="email@georgfischer.com" onInput={this.handleInput}/>
				</div>
				<div className="tc mv3 w-100">
					<Input identity="password" id="password" onKeyDown={this.enterButtonListener} inputStyle={inputStyles} placeholder="Password" onInput={this.handleInput} type="password"/>
				</div>
				<div className="pb3 center">
					<Submit name="Login" styles="br3 white b grow hh3 bg-blue w-100" onClick={this.loginAttempt}/>
					<div className="fl w-100 mv2 mb2">
						<a href="#" className="fl f7 blue fl-w30 no-underline underline-hover" onClick={this.resetPass}>Reset password</a>
						<a href="#" className="fr f7 blue fl-w70 no-underline underline-hover" onClick={this.recoverPass}>Recover Account</a>
					</div>
				</div>
				<Modal
			        isOpen={this.state.modalIsOpen}
			        onRequestClose={this.closeModal}
			        shouldCloseOnOverlayClick={false}
					shouldCloseOnEsc={false}
			        style={customStyles}
			        contentLabel="Reset/Recover password"
		        >
		        {modalContent}
		    	</Modal>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/LoginPage.js